﻿$.fn.dxCtrlContentFormulaireHtml = function custom_dxCtrlContentFormulaireHtml(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentFormulaireHtml dx-ctrl");
        this.createInstance(new cdxCtrlContentFormulaireHtml(this, option));
    }
    return this;
}

window.cdxCtrlContentFormulaireHtml = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivEntete = null

    var $DivContentFormulaire = null
    var dxAssistant = null
    function mConstruit() {
        container.empty();
        container.css("position", "relative")
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")

        $DivEntete = $("<div style='width:100%;padding:0;'/>").appendTo(container)
        $DivEntete.css("padding", "0 0px 0px 0px")

        var $Table = $("<table style='width:100%'/>").appendTo($DivEntete)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:0px;'/>").appendTo($Tr)
        $TdAddFile = $Td
        var $TdToolBar = $("<td style='width:100%;'/>").appendTo($Tr)
        var lstButton = []
        lstButton.push({
            location: 'before',
            widget: 'dxButton',
            showText: "always",
            visible: typeof option.data64 == 'undefined',
            options: {
                text: 'Prévisualiser',
                focusStateEnabled: false,
                tabIndex: -1, // <-- empêche le focus clavier
                onClick(e) {
                    e.event.stopPropagation();
                    mShowPrevi()
                }
            }
        })
        lstButton.push({
            location: 'before',
            widget: 'dxButton',
            showText: "always",
            template(itemData, itemIndex, itemElement) {
                var opt = {
                    icon: 'fas fa-rotate-left',
                    txtTooltip: "Annuler",
                    focusStateEnabled: false,
                    tabIndex: -1, // <-- empêche le focus clavier
                    visible: false,
                    onClick: function (e) {
                    }
                }
                dxBtUndo = $("<div/>").appendTo(itemElement).dxCtrlButton(opt).dxCtrlButton("instance");
            }
        })
        lstButton.push({
            location: 'before',
            widget: 'dxButton',
            showText: "always",
            template(itemData, itemIndex, itemElement) {
                var opt = {
                    icon: 'fas fa-rotate-right',
                    txtTooltip: "Rétablir",
                    focusStateEnabled: false,
                    tabIndex: -1, // <-- empêche le focus clavier
                    visible: false,
                    onClick: function (e) {
                    }
                }
                dxBtRedo = $("<div/>").appendTo(itemElement).dxCtrlButton(opt).dxCtrlButton("instance");
            }
        })
        lstButton.push({
            location: 'after',
            widget: 'dxDropDownButton',
            showText: "always",
            options: {
                items: ["Sauvegarder dans la box".toUpperCase()],
                text: 'Changer modèle',
                focusStateEnabled: false,
                splitButton: true,
                dropDownOptions: { width: 230 },
                tabIndex: -1, // <-- empêche le focus clavier
                onButtonClick(e) {
                    //changer de modèle
                    e.event.stopPropagation();
                    $("<div/>").appendTo("body").dxCtrlSelectModele({
                        bddCtrl: option.bddCtrl,
                        type: "formulaire",
                        disableConcepteurSignature: true,
                        onSelectConcepteurVide: function () {
                            dxAssistant.mSetHtml('<html assistant2="1"><body></body></html>', function () {
                                jaugeDemarrage.mHide()
                                isDirty = true
                            })
                        },
                        onSelectFile: function (pathName) {
                            mChargeSelectedModele(pathName)
                        }
                    }).dxCtrlSelectModele("instance")

                    function mChargeSelectedModele(pathName) {
                        jaugeDemarrage.mShow()
                        option.bddCtrl.mAjaxCall({ command: "getdataformulairefromz", id_fichier: pathName }, function (data) {
                            Me.mChangeObjet(data.objet)
                            if (isFileData()) option.data.objet = data.objet

                            dxAssistant.mSetHtml(data.html, function () {
                                jaugeDemarrage.mHide()
                                isDirty = true
                            })
                        })
                    }

                },
                onItemClick(e) {
                    //sauvegarder comme modèle
                    //if (option.bddCtrl.objCptCli.objetMetier.hasBox()) {
                    if (Me.isDirty()) {
                        Me.mSave(function () { mFinalise() })
                    } else { mFinalise() }
                    function mFinalise() {
                        var objet = dxAssistant.mNom()
                        if (typeof objet == "undefined" || objet == null || objet.length == 0) objet = "Nouveau formulaire"
                        objet = objet.remplacerTout(" ", "_")
                        objet = objet.remplacerTout(carInterditFichier, "")
                        if (objet.length > 50) objet = objet.substring(0, 50)
                        //objet += ".docz"
                        pathNomFichier = option.bddCtrl.repertoireBrouillon + "/" + objet + ".formz"

                        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                            height: "auto",
                            width: 450,
                            showMaximize: false,
                            contentTemplate: function (contentElement) {
                                var $Div = $("<div style='font-size:200%;font-weight:bold;padding:15px;text-align:center;'>Sauvegarder comme modèle</div>").appendTo(contentElement)
                                var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                                var $Tr = $("<tr/>").appendTo($Table)
                                var $Td = $("<td style='width:50%'/>").appendTo($Tr)
                                var $TdContainerAccordion = $("<td style='width:250px;min-width:380px;'/>").appendTo($Tr)
                                var $Td = $("<td style='width:50%'/>").appendTo($Tr)

                                $("<div/>").dxCtrlPopupEnregistrerSous({
                                    bddCtrl: option.bddCtrl,
                                    extension: ".formz",
                                    mode: "single",
                                    type: "enregistrersous",
                                    selectedDirectory: option.bddCtrl.repertoireBrouillon,
                                    fileNameWithoutExtension: objet,
                                    title: "Enregistrer sous...",
                                    onValide: function (lstPathName) {
                                        var pathName = lstPathName[0]
                                        if (pathName == pathNomFichier) {
                                            Me.mExportBox(pathName, function () {
                                                mNotify("Votre document a été sauvegardé", "success", 6000)
                                            })
                                        } else {
                                            mVerifFileExist(option.bddCtrl, pathName, function (exist) {
                                                if (exist) {
                                                    mConfirmPopup("<div style='padding-bottom:20px;'>Le fichier que vous avez choisi<br/>existe déjà.<br/><br/>Voulez-vous remplacer le fichier<br/>avec votre document ?</div>", function () {
                                                        Me.mExportBox(pathName, function () {
                                                            mNotify("Votre document a été sauvegardé", "success", 6000)
                                                        })
                                                    })
                                                } else {
                                                    Me.mExportBox(pathName, function () {
                                                        mNotify("Votre document a été sauvegardé", "success", 6000)
                                                    })
                                                }
                                            })
                                        }

                                    }
                                })
                            }
                        }).dxCtrlPopupBase("instance")
                        popup.show()
                    }
                }
            }
        })
        if (typeof option.onSlide != 'undefined') {
            var isSlideDown = true
            lstButton.push({
                location: 'after',
                widget: 'dxButton',
                showText: "always",
                options: {
                    icon: 'fas fa-chevron-up',
                    hint: "Réduire",
                    visible: true,
                    focusStateEnabled: false,
                    tabIndex: -1, // <-- empêche le focus clavier
                    onClick: function (e) {
                        isSlideDown = !isSlideDown
                        option.onSlide(isSlideDown)
                        e.component.option("icon", ((isSlideDown) ? 'fas fa-chevron-up' : 'fas fa-chevron-down'))
                        e.component.option("hint", ((isSlideDown) ? 'Réduire' : 'Agrandir'))
                    },
                    onFocusIn: function (e) {
                        e.component.blur(); // retire le focus immédiatement
                    }
                }
            })
        }
        if (option.allowFullScreen) {
            var isFullScreen = false
            lstButton.push({
                location: 'after',
                widget: 'dxButton',
                showText: "always",
                options: {
                    icon: 'dx-icon fas fa-arrow-up-right-from-square',
                    hint: "Agrandir/Réduire",
                    visible: true,
                    focusStateEnabled: false,
                    tabIndex: -1, // <-- empêche le focus clavier
                    onClick: function (e) {
                        isFullScreen = !isFullScreen
                        if (isFullScreen) {
                            container.css({
                                "position": "fixed",
                                top: 0,
                                left: 0,
                                "z-index": 10
                            })
                        } else {
                            container.css({
                                "position": "relative",
                                top: "",
                                left: "",
                                "z-index": ""
                            })
                        }
                        e.component.option("icon", ((isFullScreen) ? 'fas fa-arrow-up-right-from-square fa-rotate-180' : 'fas fa-arrow-up-right-from-square'))
                    },
                    onFocusIn: function (e) {
                        e.component.blur(); // retire le focus immédiatement
                    }
                }
                //template(itemData, itemIndex, itemElement) {
                //    var opt = {
                //    }
                //    var dxBtSlide = $("<div tabindex='-1'/>").appendTo(itemElement).dxCtrlButton(opt).dxCtrlButton("instance");
                //}
            })
        }
        dxToolBar = $("<div/>").appendTo($TdToolBar).dxToolbar({
            visible: !option.readOnly,
            items: lstButton,
            onContentReady: function (e) {
                e.component.element().find(".dx-toolbar-items-container").css("height", "42px")
            }
        }).dxToolbar("instance")
        //}

        $DivContentFormulaire = $("<div/>").appendTo(container)
        $DivContentFormulaire.css({
            "position": "relative",
            "width": "100%",
            "border": theme.border
        })
        resizeObserver.mAdd([$DivEntete, $DivContentFormulaire], function () { $DivContentFormulaire.css("height", "calc(100% - " + ($DivEntete.innerHeight()) + "px)") })()

        mConstruitContent()


        function mConstruitContent() {
            $DivContentFormulaire.empty()
            Me.isInit = false

            if (dxBtUndo) dxBtUndo.option("visible", true)
            if (dxBtRedo) dxBtRedo.option("visible", true)

            dxAssistant = $("<div style='width:100%;height:100%;'/>").appendTo($DivContentFormulaire).dxCtrlAssistantHtmlEmail({
                bddCtrl: option.bddCtrl,
                html: option.dataHtml.html,
                dxBtUndo: dxBtUndo,
                dxBtRedo: dxBtRedo,
                isFormulaire: true,
                onDemandePrevisualisation: function () {
                    Me.mSaveAuto(function () {
                        if (typeof option.onDemandePrevisualisation != 'undefined') { option.onDemandePrevisualisation() }
                        else { mShowPrevi(); }
                    })
                },
                onDeclencheSaveAuto: function (funcFin) {
                    Me.mSaveAuto(funcFin)
                },
                fullScreen: option.fullScreen,
                onSwitchFullScreen: function () {
                    if (popupFullScreen) popupFullScreen.hide()
                    popupFullScreen = null
                    option.onSwitchFullScreen()
                },
                onContentReady: function (component) {
                    dxAssistant = component
                    Me.isInit = true
                    if (typeof option.onContentReady != 'undefined') option.onContentReady(Me)
                    if (typeof onContentReady != 'undefined') onContentReady(Me)
                }
            }).dxCtrlAssistantHtmlEmail("instance")

            mStartSaveAuto()

        }
    }

    this.mGetHtmlUrl = function (funcOk) {
        if (typeof option.data.id_fichier != 'undefined') {
            option.bddCtrl.mAjaxCall({
                command: "gethtmlurldataemailfichier",
                path_nom_fichier: option.data.id_fichier
            }, function (data) {
                funcOk(data.urlhtml)
            })
        } else {
            option.bddCtrl.mAjaxCall({
                command: "gethtmlurldataemailbdd",
                nom_table: option.bddCtrl.getObjet(option.data).mGetTable().nom,
                id: option.bddCtrl.getObjet(option.data).cle()
            }, function (data) {
                funcOk(data.urlhtml)
            })
        }
    }

    function mShowPrevi() {
        jauge.mShow()
        Me.mGetHtmlUrl(function (urlHtml) {
            $("<div/>").appendTo("body").dxCtrlFormulairePrevisualisation({
                bddCtrl: option.bddCtrl,
                urlHtml: urlHtml
            })
            jauge.mHide()
        })
    }

    this.isDirty = function (value) {
        //if (typeof value != 'undefined') lstTagIsDirty = value
        return dxAssistant.isDirty(value)
    }

    this.objet = function (value) { return dxAssistant.mTitre(value)  }

    var onCloseInitial = null
    function mStartSaveAuto() {
        timeOutSaveAuto = window.setTimeout(function () { Me.mSaveAuto() }, 10000)
        var popupPage = null
        if (typeof page.mGetPopupPage != 'undefined') popupPage = page.mGetPopupPage(option.data)
        if (popupPage != null) {
            onCloseInitial = popupPage.option("onClose")
            popupPage.option("onClose", function (e, funcFin) {
                Me.mStopSaveAuto(function () {
                    if (typeof onCloseInitial != 'undefined') onCloseInitial(e)
                    if (typeof funcFin != 'undefined') funcFin()
                })
            })
        }
    }
    this.saveAuto = true
    this.mStopSaveAuto = function (funcFin) {
        Me.saveAuto = false
        window.clearTimeout(timeOutSaveAuto)
        var popupPage = null
        if (typeof page.mGetPopupPage != 'undefined') popupPage = page.mGetPopupPage(option.data)
        if (popupPage != null) {
            popupPage.option("onClose", function (e, funcFin) {
                if (typeof onCloseInitial != 'undefined') onCloseInitial(e)
                if (typeof funcFin != 'undefined') funcFin()
            })
        }
        this.mSaveAuto(funcFin)
    }
    var timeOutSaveAuto = null
    this.mSaveAuto = function (funcFin, forcer) {
        if (typeof forcer == "undefined") forcer = false
        window.clearTimeout(timeOutSaveAuto)
        if (Me.isDirty() || forcer) {
            Me.mSave(function (parametre) {
                if (typeof funcFin != 'undefined') funcFin(parametre)
                if (Me.saveAuto && container.closest("body").length > 0) timeOutSaveAuto = window.setTimeout(function () { Me.mSaveAuto() }, 5000)
                if (option.onValueChanged) option.onValueChanged()
            })
        } else {
            if (typeof funcFin != 'undefined') funcFin()
            if (Me.saveAuto && container.closest("body").length > 0) timeOutSaveAuto = window.setTimeout(function () { Me.mSaveAuto() }, 5000)
        }
    }
    function isFileData() {
        var result = false
        if (typeof option.data.id_fichier != 'undefined') { }
        else { result = true }
        return result
    }
    this.mSave = function (funcFin) {
        if (!dxAssistant.isInit) {
            window.setTimeout(function () { Me.mSave(funcFin) }, 100)
            return
        }
        Me.isDirty(false)
        if (isFileData()) {
            if (option.bddCtrl.getObjet(option.data).cle() == null) {
                var objets = option.bddCtrl.getObjets()
                objets.mAddData([option.data], "save")
                objets.mSave(function () { mSaveEmailBase() })
            } else { mSaveEmailBase() }
        } else { mSaveEmailBase() }

        function mSaveEmailBase() {
            var opt = {
                html: dxAssistant.mGetHtml(),
                extension: ".formz"
            }

            if (typeof option.data.id_fichier != 'undefined') {
                opt.command = "savedataemail_fichier"
                opt.path_nom_fichier = option.data.id_fichier
            } else {
                opt.command = "savedataemail_data"
                opt.nom_table = option.bddCtrl.getObjet(option.data).mGetTable().nom
                opt.id = option.bddCtrl.getObjet(option.data).cle()
                opt.objet = dxAssistant.mTitre()
            }

            option.bddCtrl.mAjaxCall(opt, function (data) {
                if (opt.command == "savedataemail_fichier") $(window).trigger("updatelstfile");
                if (typeof data.bddupdate != 'undefined' && typeof option.data != 'undefined') {
                    var nomTable = Object.keys(data.bddupdate)[0]
                    var id = data.bddupdate[nomTable][0]["id_" + nomTable]
                    option.data.body_txt = data.bddupdate[nomTable][0].body_txt
                    option.data.objet = data.bddupdate[nomTable][0].objet
                    option.data.nom = data.bddupdate[nomTable][0].nom
                } else if (opt.command == "savedataemail_fichier") {
                    option.data.taille_octet = data.taille_octet
                    option.data.taille_octet_ss_image = data.taille_octet_ss_image
                }
                if (typeof data.id_fichier != 'undefined') option.path_nom_fichier = data.id_fichier
                if (typeof data.path_nom_fichier != 'undefined') option.path_nom_fichier = data.path_nom_fichier
                if (isFileData()) {
                    option.bddCtrl.triggerFunctionOnModifiedItemData(option.bddCtrl.getObjet(option.data).mGetTable().nom, "modif", data.bddupdate[option.bddCtrl.getObjet(option.data).mGetTable().nom][0])
                }
                if (typeof option.onSave != 'undefined') option.onSave()
            }, function (data) {
                if (typeof funcFin != 'undefined') funcFin()
            })
        }
    }

    this.mExportBox = function (pathNomFichier, funcFin) {
        var opt = {
            html: dxAssistant.mGetHtml(),
            extension: ".formz"
        }
        opt.command = "savedataemail_fichier"
        opt.path_nom_fichier = pathNomFichier
        option.bddCtrl.mAjaxCall(opt, function (data) {
            funcFin()
        }, function (data) {
        })
    }

    this.focus = function () { }
    this.element = function () { return container }

    mConstruit();
}